import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { OnboardingRoutingModule } from './onboarding-routing.module';

import { OnboardingComponent } from './onboarding/onboarding.component';
import { CompanyDetailsComponent } from './company-details/company-details.component';
import { MachineDetailsComponent } from './machine-details/machine-details.component';
import { AccountDetailsComponent } from './account-details/account-details.component';
import { SubmittedComponent } from './submitted/submitted.component';
import { TagInputModule } from 'ngx-chips';
import { AutocompleteLibModule } from 'angular-ng-autocomplete';
import { TermsComponent } from './terms/terms.component';
import { NgMultiSelectDropDownModule } from 'ng-multiselect-dropdown';
import { NgSelectModule, NgOption } from '@ng-select/ng-select';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatSelectModule } from '@angular/material/select';
import { MatOptionModule } from '@angular/material/core';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { FileUploadModule } from '@iplab/ngx-file-upload';
import { SheetMetalComponent } from './machine-popups/sheet-metal/sheet-metal.component';
import { SubmitOtpComponent } from './machine-popups/submit-otp/submit-otp.component';
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import { OtherMachinesComponent } from './machine-popups/other-machines/other-machines.component';
import { NewPrintProcessComponent } from './machine-popups/new-print-process/new-print-process.component';
import { NewIndustryComponent } from './machine-popups/new-industry/new-industry.component';
import { NewCertificatesComponent } from './machine-popups/new-certificates/new-certificates.component';
import { NewPostProcessComponent } from './machine-popups/new-post-process/new-post-process.component';
import { EditMachineDetailsComponent } from './machine-popups/edit-machine-details/edit-machine-details.component';

@NgModule({
  declarations: [
    OnboardingComponent,
    CompanyDetailsComponent,
    MachineDetailsComponent,
    AccountDetailsComponent,
    SubmittedComponent,
    TermsComponent,
    SheetMetalComponent,
    SubmitOtpComponent,
    OtherMachinesComponent,
    NewPrintProcessComponent,
    NewIndustryComponent,
    NewCertificatesComponent,
    NewPostProcessComponent,
    EditMachineDetailsComponent,
    
  ],
  imports: [
    TagInputModule,
    CommonModule,
    ReactiveFormsModule,
    OnboardingRoutingModule,
    AutocompleteLibModule,
    NgMultiSelectDropDownModule,
    NgSelectModule,
    FormsModule,
    MatCheckboxModule,
    MatSelectModule,
    MatOptionModule,
    MatInputModule,
    MatRadioModule,
    FileUploadModule,
    MatAutocompleteModule
  ]
})
export class OnboardingModule { }
